import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  countrySelect: {
    marginRight: theme.spacing(1),
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      paddingRight: theme.spacing(3),
    },
  },
  flag: {
    fontSize: 20,
    lineHeight: 1,
  },
  callingCode: {
    color: grey[600],
    marginRight: theme.spacing(0.5),
    whiteSpace: "nowrap",
    paddingTop: theme.spacing(0.3),
  },
  adornment: {
    marginRight: theme.spacing(0.5),
  },
  menuPaper: {
    maxHeight: theme.spacing(40),
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  menuName: {
    flex: 1,
  },
  menuCode: {
    color: grey[600],
    marginLeft: theme.spacing(2),
  },
}));
